import React from 'react';

const AnchorLogoSquare = ({}) => (
  <svg
    viewBox="0 0 33 33"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <rect id="path-1" width="33" height="33" rx="5.115" />
      <filter
        x="-27.3%"
        y="-27.3%"
        width="154.5%"
        height="154.5%"
        filterUnits="objectBoundingBox"
        id="filter-3"
      >
        <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation="3"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <linearGradient
        x1="50%"
        y1="-4.737%"
        x2="50%"
        y2="137.63%"
        id="linearGradient-4"
      >
        <stop stopColor="#AE4EFF" offset="0%" />
        <stop stopColor="#8940FA" offset="44.522%" />
        <stop stopColor="#893FFA" offset="65.974%" />
        <stop stopColor="#8E47FA" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <use filter="url(#filter-3)" xlinkHref="#path-1" fill="#000" />
        <g mask="url(#mask-2)">
          <g transform="translate(5.994 5.092)">
            <polygon
              fill="#FFF"
              style={{ mixBlendMode: 'overlay' }}
              points="0 0 10.5058594 7.86328125 21.0117187 0 21.0117187 15.7265625 10.5058594 23.5898438 0 15.7265625"
            />
            <polygon
              fillOpacity="0.7"
              fill="#FFF"
              style={{
                mixBlendMode: 'overlay',
              }}
              points="0 15.7265625 10.5058594 7.86328125 21.0117187 15.7265625 10.5058594 23.5898438"
            />
            <polygon
              fill="#FFF"
              style={{
                mixBlendMode: 'soft-light',
              }}
              points="0 0 10.5058594 23.5898438 21.0117187 0 10.5058594 7.86328125"
            />
            <path
              d="M0,0 L10.5058594,23.5898438 L0,3.83496094 L0,0 Z M21.0117187,0 L21.0117187,3.83496094 L10.5058594,23.5898438 L21.0117187,0 Z"
              fillOpacity="0.25"
              fill="#000"
              style={{
                mixBlendMode: 'overlay',
              }}
            />
          </g>
          <g>
            <g>
              <rect fill="#8940FA" width="33" height="33" />
              <rect fill="url(#linearGradient-4)" width="33" height="33" />
              <path
                d="M16.9920125,17.2221735 L10.4841492,17.2221735 C10.191562,17.8056871 9.58210924,18.20784 8.87935718,18.20784 C7.89263262,18.20784 7.08984375,17.4150123 7.08984375,16.4405312 C7.08984375,15.4660501 7.89263262,14.6734402 8.87935718,14.6734402 C9.56936473,14.6734402 10.1694263,15.0610326 10.4679196,15.6273701 L17.0127102,15.6273701 C16.807883,14.7135884 16.2647941,13.9339589 15.5330292,13.5329302 L14.9847508,13.2325705 L15.9844876,11.5390993 L16.5102702,11.8287863 C17.2599074,12.2417537 17.8955221,12.8805899 18.3483039,13.6762491 C18.805276,14.4795317 19.0555962,15.411322 19.0721371,16.3707742 L19.0723577,16.3812291 L19.0721371,16.3914661 C19.0555962,17.3509183 18.805276,18.2829265 18.3483039,19.0862091 C17.8955221,19.8818683 17.2599074,20.5207045 16.5102702,20.9334541 L15.9844876,21.2231411 L14.9847508,19.5296698 L15.5330292,19.2293101 C16.2413775,18.8411145 16.772932,18.0981607 16.9920125,17.2221735 Z M8.84466798,15.8999215 C8.552444,15.8999215 8.31491554,16.1347204 8.31491554,16.4231006 C8.31491554,16.7116986 8.552444,16.9462798 8.84466798,16.9462798 C9.13689195,16.9462798 9.37442041,16.7116986 9.37442041,16.4231006 C9.37442041,16.1347204 9.13689195,15.8999215 8.84466798,15.8999215 Z M23.7280804,17.5181519 L23.7571925,16.4998911 L23.7280804,15.4818481 C23.3564597,11.8566216 21.3358136,8.80205689 18.5238471,7.29938703 L19.5871013,5.54296875 C23.2338359,7.50216796 25.7767358,11.6608106 25.8620873,16.4998911 C25.7767358,21.3394072 23.2338359,25.4980498 19.5871013,27.4570312 L18.5238471,25.700613 C21.3358136,24.1979431 23.3566802,21.1435962 23.7280804,17.5181519 Z M17.7659453,24.3652075 L16.754299,22.65148 L17.0138821,22.5090324 C17.9126086,22.0167822 18.6979743,21.2616356 19.2848483,20.3257069 C19.8838523,19.3706109 20.2629715,18.245841 20.381846,17.0722818 L20.4010336,16.384874 L20.381846,15.6976841 C20.2629715,14.523907 19.8838523,13.399355 19.2848483,12.444259 C18.6977538,11.5081124 17.9126086,10.7531837 17.0138821,10.2607157 L16.754299,10.1184859 L17.7659453,8.40475831 L18.0151627,8.54197849 C19.2899209,9.24419731 20.3741269,10.3362957 21.1497886,11.6997851 C21.9422118,13.092461 22.3762471,14.7107878 22.4049181,16.3800822 L22.4051387,16.384874 L22.4049181,16.3898836 C22.3762471,18.059178 21.9422118,19.6775049 21.1497886,21.0701808 C20.3741269,22.4336702 19.2899209,23.5257685 18.0151627,24.2279874 L17.7659453,24.3652075 Z"
                fill="#FFF"
              />
            </g>
            <path d="M6.5715862,-1.15367837e-15 C4.28650251,-7.33915304e-16 3.45787595,0.237924656 2.62248351,0.684697423 C1.78709107,1.13147019 1.13147019,1.78709107 0.684697423,2.62248351 C0.237924656,3.45787595 -1.02842077e-16,4.28650251 1.76999965e-16,6.5715862 L0,0 L6.5715862,0 Z M26.4284138,0 L33,0 L33,6.5715862 C33,4.28650251 32.7620753,3.45787595 32.3153026,2.62248351 C31.8685298,1.78709107 31.2129089,1.13147019 30.3775165,0.684697423 C29.542124,0.237924656 28.7134975,-1.54263116e-16 26.4284138,2.65499948e-16 Z M33,26.4284138 L33,33 L26.4284138,33 C28.7134975,33 29.542124,32.7620753 30.3775165,32.3153026 C31.2129089,31.8685298 31.8685298,31.2129089 32.3153026,30.3775165 C32.7620753,29.542124 33,28.7134975 33,26.4284138 Z M6.5715862,33 L0,33 L0,26.4284138 C-7.85336343e-16,28.7134975 0.237924656,29.542124 0.684697423,30.3775165 C1.13147019,31.2129089 1.78709107,31.8685298 2.62248351,32.3153026 C3.45787595,32.7620753 4.28650251,33 6.5715862,33 Z" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default AnchorLogoSquare;
